import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';

interface User {
  id: string;
  email: string;
  email_verified: boolean;
}

interface AuthResponse {
  user: User;
}

interface MeResponse {
  user: User;
}

export function useMe() {
  return useQuery<MeResponse>({
    queryKey: ['mr-me'],
    queryFn: () => api.get<MeResponse>('/auth/me'),
    retry: false,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (creds: { email: string; password: string }) =>
      api.post<AuthResponse>('/auth/login', creds),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mr-me'] });
    },
  });
}

export function useRegister() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (creds: {
      email: string;
      password: string;
      consents?: {
        analysis: boolean;
        deidentified_research: boolean;
        email_reminders: boolean;
        marketing: boolean;
      };
    }) => api.post<AuthResponse>('/auth/register', creds),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mr-me'] });
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<void>('/auth/logout', {}),
    onSettled: () => {
      qc.clear();
      window.location.href = '/portal/login';
    },
  });
}
